import './SideBarTooltip.css';

export const createTooltip = (target: HTMLSpanElement) => {
  const targetRect = target.getBoundingClientRect();
  const tooltipWrapper = document.createElement('div');
  tooltipWrapper.className = 'tooltip_wrapper';
  tooltipWrapper.style.top = `${targetRect.top + window.scrollY}px`;
  tooltipWrapper.style.left = `${targetRect.left + 49}px`;
  tooltipWrapper.style.height = `${targetRect.height}px`; // 높이는 동적 설정
  
  const tooltip = document.createElement('div');
  tooltip.className = 'tooltip';
  tooltip.style.height = `${targetRect.height}px`; // 높이는 여전히 동적 설정
  tooltip.innerText = target.dataset.title || '';
  
  tooltipWrapper.appendChild(tooltip);
  document.body.appendChild(tooltipWrapper);
};

export const removeTooltip = () => {
  const tooltip = document.querySelector('.tooltip_wrapper');
  if (tooltip) {
    document.body.removeChild(tooltip);
  }
};
